import { render, staticRenderFns } from "./modalPartesExamenPies.vue?vue&type=template&id=6a377a08"
import script from "./modalPartesExamenPies.vue?vue&type=script&lang=js"
export * from "./modalPartesExamenPies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports